module.exports = __webpack_public_path__ + "img/yhkb.63ca3432.png";